<template>
  <div class="details">
    <div class="details_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
      <div class="my">详情</div>
    </div>
    <div class="details_bottom">
      <div class="details_bottom_list">
        <p
          style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap"
        >
          {{ details_list.title }}
        </p>
        <div>
          <span>{{ details_list.sendTime }}</span>
        </div>
        <p
          style="
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
          "
        >
          未通过原因：
        </p>
        <p
          style="
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
          "
        >
          {{ details_list.content }}
        </p>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "details",
  data() {
    return {
      id: "",
      details_list: [],
    };
  },
  created() {
    this.id = this.$route.query.id;
  },
  mounted() {
    this.look();
  },
  methods: {
    to() {
      window.history.go(-1);
    },
    async look() {
      let res = await this.$apis.userServe.msgDetails({ sysMsgId: this.id });
      this.details_list = res.data;
    },
  },
};
</script>
  
  <style lang="scss">
.details {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .details_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    .my {
      width: 72px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
    }
  }
  .details_bottom {
    width: 100%;
    height: 100%;
    margin-top: 13px;
    .details_bottom_list {
      width: 94%;
      background: #fff;
      border-radius: 8px 8px 8px 8px;
      opacity: 1;
      margin-left: 12px;
      overflow: hidden;
      p {
        font-size: 16px;
        font-family: PingFangSC-Heavy, PingFang SC;
        font-weight: 800;
        color: #333333;
        margin-left: 20px;
        margin-top: 21px;
      }
      div {
        margin-top: 7px;
        span {
          font-size: 13px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #999999;
          margin-left: 20px;
        }
      }
      .content {
        margin-left: 20px;
        margin-top: 21px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }
    }
  }
}
</style>